import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=7ca15bdf&scoped=true&"
import script from "./UserCard.vue?vue&type=script&lang=ts&"
export * from "./UserCard.vue?vue&type=script&lang=ts&"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=7ca15bdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca15bdf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca15bdf')) {
      api.createRecord('7ca15bdf', component.options)
    } else {
      api.reload('7ca15bdf', component.options)
    }
    module.hot.accept("./UserCard.vue?vue&type=template&id=7ca15bdf&scoped=true&", function () {
      api.rerender('7ca15bdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/UserCard.vue"
export default component.exports